import React from 'react';
import {
  StackItem,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import {
  MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';

export interface ResponsiveHiddenContainerNodeProperties {
  breakpoints?: {
    mobile?: boolean;
    mobileLandscape?: boolean;
    tablet?: boolean;
    laptop?: boolean;
    desktop?: boolean;
  };
}

export type ResponsiveHiddenContainerNode = MasonryEngineNode<
  'responsiveHiddenContainer',
  ResponsiveHiddenContainerNodeProperties,
  {},
  {
    content: MasonryEngineNode<string, any>[];
  }
>;

export type ResponsiveHiddenContainerRendererProps =
  MasonryEngineNodeRendererProps<ResponsiveHiddenContainerNode>;

export const ResponsiveHiddenContainerRenderer = ({
  breakpoints = {},
  content,
}: ResponsiveHiddenContainerRendererProps) => {
  // Check current screen size for each breakpoint
  const isMobile = useMediaQuery(queryHelpers.down('mobileLandscape'));
  const isMobileLandscape = useMediaQuery(queryHelpers.only('mobileLandscape'));
  const isTablet = useMediaQuery(queryHelpers.only('tablet'));
  const isLaptop = useMediaQuery(queryHelpers.only('laptop'));
  const isDesktop = useMediaQuery(queryHelpers.up('desktop'));

  // If breakpoint is true and current screen size matches that breakpoint, return null
  if (breakpoints?.mobile && isMobile) {
    return null;
  }
  if (breakpoints?.mobileLandscape && isMobileLandscape) {
    return null;
  }
  if (breakpoints?.tablet && isTablet) {
    return null;
  }
  if (breakpoints?.laptop && isLaptop) {
    return null;
  }
  if (breakpoints?.desktop && isDesktop) {
    return null;
  }

  return <StackItem>{content}</StackItem>;
};
